import { Injectable } from '@angular/core';

import {
	DeleteNodePictureResponse,
	SetNodeImageFromUrlResponse,
	SetNodePictureResponse,
} from '@reach/interfaces/node-pictures/node-images.interface';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class NodeImagesApiService extends BaseApiService {
	protected commonPath = ['node-pictures'];

	public async setNodeImage(nodeId: number, image: File): Promise<SetNodePictureResponse> {
		const formData = new FormData();
		formData.append('image', image);

		return await this.http.post<SetNodePictureResponse>(this.url(`${nodeId}`), formData);
	}

	public async setNodeImageUrl(
		nodeId: string,
		url: string
	): Promise<SetNodeImageFromUrlResponse> {
		return await this.http.post<SetNodeImageFromUrlResponse>(this.url(nodeId, 'url'), { url });
	}

	public async deleteNodeImage(nodeId: number): Promise<DeleteNodePictureResponse> {
		return await this.http.delete<DeleteNodePictureResponse>(this.url(`${nodeId}`));
	}
}
